var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.newVersion)?_c('div',{staticClass:"sw-new-version"},[_c('button',{on:{"click":_vm.reload}},[_c('img',{attrs:{"src":require("@/assets/reload.svg"),"alt":"reload"}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }